<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="/home">Home</a></li>
                            <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Company:</span>
                                        <v-select v-model="params.company" class="form-control" type="text" label="name" :options="companies" :reduce="companies => companies.code" name="company" placeholder="Select Company" :value="companies => companies.code"></v-select>
                                    </div>
                                </div>
<!--                                                            <div class="col-sm-3" v-if="$gate.isMISAdmin()">-->
<!--                                                                <div class="form-group">-->
<!--                                                                    <span class="right badge badge-secondary">Search by Branch:</span>-->
<!--                                                                    <v-select v-model="params.branch" type="text" label="fullname" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select Branch" :value="branches => branches.branch_code"></v-select>-->
<!--                                                                </div>-->
<!--                                                            </div>-->
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Date:</span>
                                        <input type="date" class="form-control" placeholder="From Date" v-model="params.date">
                                    </div>
                                </div>
                                <!--                            <div class="col-md-3">-->
                                <!--                                <div class="form-group">-->
                                <!--                                    <span class="right badge badge-secondary">To Date:</span>-->
                                <!--                                    <input type="date" class="form-control" placeholder="To Date" v-model="todate">-->
                                <!--                                </div>-->
                                <!--                            </div>-->
<!--                                <div class="col-sm-3">-->
<!--                                    <div class="form-group">-->
<!--                                        <span class="right badge badge-secondary">Sync Type:</span>-->
<!--                                        <select class="form-control" v-model="params.sync_type">-->
<!--                                            <option value="SALES">SALES</option>-->
<!--                                            <option value="STOCK">STOCK</option>-->
<!--                                        </select>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button class="btn btn-primary" style="width:100% !important;" @click="getERPSalesReports">Get Report from ERP</button>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
                                    </div>
                                </div>
                            </div>
                            <!--                        <div class="row">-->
                            <!--                            -->
                            <!--                        </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="col-md-12" v-if="data!=null">
                <br>
                <div class="card card-primay card-outline">
                    <div class="card-body">
                        <table class="table table-hover table-striped table-bordered">
                            <thead>
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Company</th>
                                <th scope="col">Start Date</th>
                                <th scope="col">End Date</th>
                                <th scope="col">ERP Report Type</th>
                                <th scope="col">Synced By</th>
                                <th scope="col">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="j in data">
                                <td>{{j.id}}</td>
                                <td>{{j.company_code}}</td>
                                <td>{{j.start_date}}</td>
                                <td>{{j.end_date}}</td>
                                <td>{{j.user.user_detail}}</td>
                                <td v-if="j.report_type=='SALES'"><span class="badge badge-secondary">{{j.report_type}}</span></td>
                                <td><button class="btn btn-danger" @click="viewSalesReport(j)">View Data</button></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination :pagination="pagination"
                                    @prev="getERPSalesReports(pagination.prevPageUrl)"
                                    @next="getERPSalesReports(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <loading :show="lshow" :label="llabel"> </loading>

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
import { parse } from "postcss";
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log('Component mounted.')
    },

    components: {loading, pagination: Pagination},

    created(){
        this.getCompanies();
        this.getBranches();
        this.getERPSalesReports();
    },

    data(){
        return{
            data: [],
            results: '',
            lshow: false,
            llabel: 'Syncing. Do not close or change this page...',
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },

            params: new Form({
                company: '',
                branch: '',
                division: '',
                category: '',
                product: '',
                brand: '',
                date: null,
                sync_type: null
            }),
            branches: [],
            branch:'',
            company:'',
            companies:[]
        }
    },

    methods: {
        getBranches(){
            axios.post("/api/getSAPBranches")
                .then(response => {
                    this.branches = response.data;
                })
        },
        reset(){
            this.getCompanies();
            this.params.reset();
        },
        getCompanies(){
            axios.post("/api/getCompanies")
                .then(response => {
                    this.companies = response.data;
                })
        },
        getERPSalesReports(){
            axios.post("/api/getERPSalesReports")
                .then(response => {
                    this.data = response.data.data;
                    this.configPagination(response.data);
                })
        },
        configPagination(data){
            this.pagination.lastPage=data.lastPage;
            this.pagination.currentPage=data.current_page;
            this.pagination.total=data.total;
            this.pagination.lastPageUrl=data.last_page_url;
            this.pagination.nextPageUrl=data.next_page_url;
            this.pagination.prevPageUrl=data.prev_page_url;
            this.pagination.from=data.from;
            this.pagination.to=data.to;
        },
        viewSalesReport(order){
            let route = this.$router.resolve('/erp-reports/sales-report/');
            // let route = this.$router.resolve('/link/to/page'); // This also works.
            window.open(route.href, '_blank');
        },
    }
}
</script>
